import { render, staticRenderFns } from "./absentees.vue?vue&type=template&id=bd814ed8&scoped=true"
import script from "./absentees.vue?vue&type=script&lang=js"
export * from "./absentees.vue?vue&type=script&lang=js"
import style0 from "./absentees.vue?vue&type=style&index=0&id=bd814ed8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd814ed8",
  null
  
)

export default component.exports